import { http } from "../http/Http";
import { ARInvoice } from "../models/ARInvoice";
import { GetByFiltersArguments } from "../models/GetByFiltersArguments";
import { ServiceResponse } from "../models/ServiceResponse";
import { ARInvoiceList } from "../models/ARInvoiceList";

export class ARInvoiceService {
    getById = async (invoiceId: string): Promise<ARInvoice> => {
        const { data } = await http.get<ARInvoice>(("ARInvoice/GetById/" + invoiceId));
        return data;
    };

    getARInvoicesByFilters = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<ARInvoiceList[]>> => {
        const { data } = await http.post<ServiceResponse<ARInvoiceList[]>>("ARInvoice/GetByFilters", apiQueryFilter);
        return data;
    };
}